export default __webpack_public_path__ + "static/media/move_to_joboffer.f3d48e6b.svg";